/**
 * Extract the desired page from the list. If the arguments are invalid, just return the original list.
 * @param list
 * @param currentPage
 * @param pageSize
 * @returns {*}
 */
export function extractPage(list, currentPage, pageSize) {
    // if page size is falsey, pagination has not been activated - just return the original list
    if (!pageSize) {
        return list;
    }
    // default current page to 1
    currentPage = currentPage || 1;
    const maxPage = maxPageNumber(list.length, pageSize);
    // limit current page to maximum page
    currentPage = Math.min(maxPage, currentPage);
    let startOffset = (currentPage - 1) * pageSize;
    return list.slice(startOffset, startOffset + pageSize);
}

/**
 * Returns a 1-indexed maximum page number
 * @param elementCount
 * @param pageSize
 */
export function maxPageNumber(elementCount, pageSize) {
    return Math.max(1, Math.ceil(elementCount / pageSize));
}
